import React from "react";
import {
  Button,
  Grid,
  IconButton,
  Icons,
  Text,
} from "@pushpress/shared-components";
import { joinStrings } from "../../../utils/misc";
import { BasicProfileFragment } from "./Attendance-generated.hooks";

interface AttendanceHeaderProps {
  profile: BasicProfileFragment;
  onDownloadClick: VoidFunction;
}

const AttendanceHeader = (props: AttendanceHeaderProps) => {
  const { profile, onDownloadClick } = props;

  const backText = `Back to ${joinStrings(
    profile.firstName,
    profile.lastName,
  )}`;

  return (
    <Grid container columnSpacing={1} className="mb-4">
      <Grid item xs={12}>
        <Button
          href={`/members/view/${profile.userUuid}`}
          buttonType="text"
          text={backText}
          icon={Icons.ArrowLeft}
          iconLocation="left"
        />
      </Grid>
      <Grid item xs={6}>
        <Text variant="heading-3" color="wolf-800">
          Attendance
        </Text>
      </Grid>
      <Grid container item xs={6} justifyContent="flex-end" className="pr-4">
        <IconButton
          icon={Icons.Download}
          tooltip={`Export attendance`}
          onClick={onDownloadClick}
        />
      </Grid>
    </Grid>
  );
};

export default AttendanceHeader;
